import React from 'react';
import { COMPANY_LEGAL_INFO } from '../../constants/legal';

const PrivacyPolicy = () => {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Privacy Policy</h2>
      <div className="space-y-4 text-gray-600">
        <p>
          In accordance with the General Data Protection Regulation (GDPR) and the French Data Protection Act,
          you have the right to access, rectify, and delete your personal data. You can exercise these rights by contacting:
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Data Controller: {COMPANY_LEGAL_INFO.name}</li>
          <li>Address: {COMPANY_LEGAL_INFO.address.street}, {COMPANY_LEGAL_INFO.address.postalCode} {COMPANY_LEGAL_INFO.address.city}</li>
          <li>Email: {COMPANY_LEGAL_INFO.email}</li>
        </ul>
        <p>
          We collect and process your data for specific, explicit, and legitimate purposes and do not process it in a way incompatible with these purposes. 
          The data we collect is adequate, relevant, and limited to what is necessary in relation to the purposes for which it is processed.
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;